module.exports = require("./es-VE.js");